import { Component, OnInit, Input, EventEmitter, Output, HostListener, OnChanges, SimpleChanges, ViewChildren, ElementRef, QueryList, AfterViewInit, ChangeDetectorRef, forwardRef, ViewChild, Renderer2, Attribute, Optional, Self } from '@angular/core';

import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { CommonService } from '@services/app.common.service';
import { fromEvent } from 'rxjs';
import { filter, debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ClientConfiguation } from '../../_enums/clientConfiguration';
import { StatusCode } from '../../_enums/Common';
import { keyValue } from '../../_models/common/keyValue';
import { Injector } from '@angular/core';


@Component({
  selector: 'app-ngx-select-dropdown',
  templateUrl: './ngx-select-dropdown.component.html',
  //styleUrls: ['./ngx-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectDropDownComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SelectDropDownComponent implements OnInit, OnChanges, AfterViewInit {

  /** value of the dropdown */
  @Input() public _value: any;

  /**
   * Get the required inputs
   */
  @Input() public options: any = [];

  /**
   * configuration options
   */
  @Input() public selectedConfig: IConfig = {};
  @Input() public config!: IConfig | IConfig[];
  configList: IConfig[] = [];

  @Input() public tabindex = 0;

  /**
   * Whether multiple selection or single selection allowed
   */
  @Input() public multiple = false;

  /**
   * Value
   */
  @Input() public disabled: boolean = false;

  /**
   * change event when value changes to provide user to handle things in change event
   */
  @Output() public byChange: EventEmitter<any> = new EventEmitter();
  @Output() public byValueChange: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public byOpen: EventEmitter<any> = new EventEmitter();

  /**
   * Event emitted when dropdown is open.
   */
  @Output() public byClose: EventEmitter<any> = new EventEmitter();
  @Input() testIdInput: string = '';
  @Input() id: string = '';

  /**
   * Toogle the dropdown list
   */
  public toggleDropdown = false;

  /**
   * Available items for selection
   */
  public availableItems: any = [];

  /**
   * Selected Items
   */
  public selectedItems: any = [];

  /**
   * Selection text to be Displayed
   */
  public selectedDisplayText: string = '';


  /**
   * Search text
   */
  public searchText: string = "";

  /**
   * variable to track if clicked inside or outside of component
   */
  public clickedInside = false;

  /**
   * variable to track keypress event inside and outsid of component
   */
  public insideKeyPress = false;

  /**
   * variable to track the focused item whenuser uses arrow keys to select item
   */
  public focusedItemIndex: number | null = null;

  /**
   * variable to track the focused item whenuser uses arrow keys to select item
   */


  /**
   * element to show not found text when not itmes match the search
   */

  public showNotFound = false;
  public pageNo = 1;

  public selectItemKey = 'selected';
  public isArrowPress = false;
  public isSearching = false;
  public selectedCount = 0;
  public orignalPlaceHolder = '';
  public isDataLoading = false;
  @Input() public customClass: string = "";
  @Input() public valdationClasss?: string = "";

  public filterdtems: any = [];
  public initialRecordLoaded = false;
  // public isTabPress = false;
  /**
   * Hold the reference to available items in the list to focus on the item when scrolling
   */
  @ViewChildren('availableOption') public availableOptions: QueryList<ElementRef>;

  private searchBox = {} as ElementRef;
  @ViewChild('searchBox') set content(content: ElementRef) {
    this.searchBox = content;
  }
  get value() {
    return this._value;
  }
  set value(val) {
    this._value = val;
    this.onChange(val);

  }
  private ngControl: NgControl | null = null;


  constructor(private cdref: ChangeDetectorRef, public _elementRef: ElementRef, public common: CommonService, private renderer: Renderer2, @Attribute('data-testid') public dataTestId: string, private injector: Injector)
  {
    this.multiple = false;
    this.availableOptions = {} as QueryList<ElementRef>;
  }

  public onChange: any = () => { // empty
  }
  public onTouched: any = () => { // empty
  }

  /**
   * click listener for host inside this component i.e
   * if many instances are there, this detects if clicked inside
   * this instance
   */
  @HostListener('click')
  public clickInsideComponent() {
    this.clickedInside = true;
  }

  /**
   * click handler on documnent to hide the open dropdown if clicked outside
   */
  @HostListener('document:click')
  public clickOutsideComponent() {
    if (!this.clickedInside) {
      this.toggleDropdown = false;
      this.resetArrowKeyActiveElement();
      if (this.multiple) {
        this.setSelectedDisplayText();
      }
    }
    this.clickedInside = false;
  }


  updateActiveConfig(config: IConfig): void {
    if (Array.isArray(this.configList)) {
      this.configList.forEach(item => item.isActive = item.buttonKey === config.buttonKey);
    }
    config.isActive = true;
    this.selectedConfig = config;
  }

  changeActiveConfiguration(config: IConfig): void {
    this.updateActiveConfig(config);
    this.clearAll();
    this.populateData();
  }

  setSelectedConfiguration(): void {
    if (Array.isArray(this.config)) {
      this.configList = this.config;
      const activeConfig = this.configList.find(conf => conf.isActive) || this.configList[0];
      this.updateActiveConfig(activeConfig);
    } else if (this.config) {
      this.selectedConfig = this.config;
    }
  }



  /**
   * click handler on documnent to hide the open dropdown if clicked outside
   */
  @HostListener('document:keydown')
  public KeyPressOutsideComponent() {
    if (!this.insideKeyPress) {
      this.toggleDropdown = false;
      this.resetArrowKeyActiveElement();
    }
    this.insideKeyPress = false;
  }
  /**
   * Event handler for key up and down event and enter press for selecting element
   * @param event
   */
  @HostListener('keydown', ['$event'])
  public handleKeyboardEvent($event: KeyboardEvent) {

    this.insideKeyPress = true;
    if ($event.keyCode === 27 || this.disabled) {
      this.toggleDropdown = false;
      this.insideKeyPress = false;
      return;
    }
    const avaOpts = this.availableOptions.toArray();
    if ($event.keyCode !== 9 && avaOpts.length === 0 && !this.toggleDropdown) {
      this.toggleDropdown = true;
    }
    // Arrow Down
    if ($event.keyCode === 40 && avaOpts.length > 0) {

      this.onArrowKeyDown();
      if (this.focusedItemIndex)
        avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
      this.isArrowPress = true;

    }
    // Arrow Up
    if ($event.keyCode === 38 && avaOpts.length) {
      this.onArrowKeyUp();
      if (this.focusedItemIndex)
        avaOpts[this.focusedItemIndex].nativeElement.focus();
      $event.preventDefault();
    }
    // Enter
    if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
      const selectedItem = this.availableItems.filter((x: any) => x[this.selectedConfig.displayKey ?? ""] == avaOpts[this.focusedItemIndex ?? 0].nativeElement.innerText)[0];
      if (this.isSearching) {
        this.selectItem(selectedItem);
      } else {
        this.selectItem(this.availableItems[this.focusedItemIndex], this.focusedItemIndex);
      }
      return false;
    }
  }
  getSelectedItemOnSearch() {

  }
  /**
   * Component onInit
   */
  public ngOnInit() {
    this.ngControl = this.injector.get(NgControl, null);

    this.setSelectedConfiguration();

    if (this.selectedConfig.serverSide)

      if (typeof this.options !== 'undefined' && Array.isArray(this.options)) {

        this.options.forEach((item: any) => {
          item[this.selectItemKey] = false;
        });
        this.initDropdownValuesAndOptions();
      }

    if (this.selectedConfig.customClass != '') {
      this.customClass = this.selectedConfig.customClass ?? "";
    }
    if (this.selectedConfig.serverSide && this.selectedConfig.loadInitialRecord) {
      this.initDropdownValuesAndOptions();
    }
    if (!this.common.isNullOrWhiteSpace(this.testIdInput)) {
      this.dataTestId = this.testIdInput;
    } else {
      this.dataTestId = this.dataTestId;
    }
  }

  /**
   * after view init to subscribe to available option changes
   */
  public ngAfterViewInit() {
    this.availableOptions.changes.subscribe(this.setNotFoundState.bind(this));

    if (this.searchBox) {
      fromEvent(this.searchBox.nativeElement, 'keyup')
        .pipe(
          filter(Boolean),
          debounceTime(500),
          distinctUntilChanged(),
          tap((text) => {
            // console.log(this.searchBox.nativeElement.value)
          })
        )
        .subscribe(($event) => {
          this.onKeyup($event);
        });
      this.renderer.listen(this.searchBox.nativeElement, 'click', (event) => {
        this.searchBox.nativeElement.removeAttribute('readonly');
        //if (this.multiple && this.toggleDropdown)
        //  return;
        if (this.multiple && !this.toggleDropdown) {
          this.selectedDisplayText = this.searchText + "";
        }
        if (this.selectedConfig.serverSide && this.selectedConfig.loadInitialRecord && !this.initialRecordLoaded) {
          this.initialRecordLoaded = true;
          this.pageNo = 1;
          this.populateData(true);
        }
        this.toggleSelectDropdown();
      });
    }
    else {
      // console.log('search issue in dropdown:' + this.customClass)
    }


  }

  public registerOnChange(fn: any) {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  public writeValue(value: any) {
    let shouldResetParentFormControlValue = false;

    if (value) {

      if (typeof value !== 'object') {
        value = [
          {
            value: value,
            id: value,
            text: value
          }
        ];
      }
      if (Array.isArray(value)) {
        if (this.multiple) {
          this._value = value;
        } else {
          try {
            if (!this.selectedConfig.dataBindingKey) {
              this._value = value[0];
              shouldResetParentFormControlValue = true
            } else {

              if (value.length > 0 && value[0].hasOwnProperty(this.selectedConfig.dataBindingKey)) {
                this._value = value[0][this.selectedConfig.dataBindingKey];
              } else {
                this._value = null;
              }
            }
          } catch (e) {
            this._value = null;
          }

        }
      } else {
        this._value = value;
      }
      this.options.forEach((item: any) => {
        item[this.selectItemKey] = false;
      });
      this.setSelectedItems(value);
      /* istanbul ignore else */
      if (this.selectedItems.length === 0) {
        this.initDropdownValuesAndOptions();
      }
      if (shouldResetParentFormControlValue && this.ngControl?.control && this.ngControl.control.value !== this._value) {
        this.ngControl.control.setValue(this._value, { emitEvent: false });
        shouldResetParentFormControlValue = false;
      }
    }

    else {
      this._value = value;
      this.setSelectedItems([]);
      this.setSelectedDisplayText();
    }
  }
  /**
   * function sets whether to show items not found text or not
   */
  public setNotFoundState() {

    this.selectedConfig.noResultsFound = this.common.GetTranslation('Common.NoRecordsFound');
    if (this.availableOptions.length === 0) {
      if (this.selectedConfig.serverSide && (this.searchText == null || this.searchText.length == 0)) {
        this.selectedConfig.noResultsFound = this.common.GetTranslation('Common.PleaseType');
      }
      this.showNotFound = true;
    } else {
      this.showNotFound = false;
    }
    this.cdref.detectChanges();
  }
  /**
   * Component onchage i.e when any of the input properties change
   * @param changes
   */
  public ngOnChanges(changes: SimpleChanges) {

    if (changes && changes.valdationClasss)
      return;
    this.selectedItems = [];
    this.searchText = '';
    this.options = this.options || [];
    if (changes.options) {
      this.availableItems = [...this.options.sort(this.selectedConfig.customComparator)];
    }
    if (changes.value && JSON.stringify(changes.value.currentValue) === JSON.stringify([])) {
      this.availableItems = [...this.options.sort(this.selectedConfig.customComparator)];
    }
    if (this.selectedConfig.serverSide) {
      this.initDropdownValuesAndOptions();
      // this.populateData(true);
    } else {
      this.initDropdownValuesAndOptions();
    }

  }
  /**
 * open dropdown
 */
  public openDropDown() {

    if (this.selectedConfig.serverSide && this.selectedConfig.loadInitialRecord && !this.initialRecordLoaded) {
      this.initialRecordLoaded = true;
      this.pageNo = 1;
      this.populateData(true);

    }

    this.toggleDropdown = false;
    this.toggleSelectDropdown();
    this.searchBox.nativeElement.focus();

  }

  /**
   * Deselct a selected items
   * @param item:  item to be deselected
   * @param index:  index of the item
   */
  public deselectItem(item: any, index: number) {

    this.selectedItems.splice(index, 1);
    this.options.forEach((option: any) => {
      if (JSON.stringify(item) === JSON.stringify(option)) {
        option[this.selectItemKey] = false;
      }
    });


    this.makeSelectedAndAvailbleArray();
    this.valueChanged();
    this.resetArrowKeyActiveElement();
  }

  /**
  * Deselct a selected items
  * @param item:  item to be deselected
  * @param index:  index of the item
  */
  public clearAll(IsfireOnChange = true, IspopulateData = true) {

    this.options.forEach((option: any) => {
      option[this.selectItemKey] = false;
    });
    this.searchText = '';
    this.makeSelectedAndAvailbleArray();
    this.valueChanged(IsfireOnChange);
    this.resetArrowKeyActiveElement();
    if (IspopulateData) {
      this.populateData();
    }
  }


  /**
   * Select an item
   * @param item:  item to be selected
   * @param index:  index of the item
   */
  public selectItem(item: any, index?: number) {
    if (item.archived == 1)
      return
    if (!this.multiple) {
      this.toggleDropdown = false;
      this.options.forEach((item: any) => {
        item[this.selectItemKey] = false;
      });
    } else {
      this.toggleDropdown = false;
    }
    const selectedItem = this.options.filter((aItem: any) => JSON.stringify(item) === JSON.stringify(aItem))[0];
    if (selectedItem) {
      selectedItem[this.selectItemKey] = true;
    }
    this.makeSelectedAndAvailbleArray();
    this.valueChanged();
    this.resetArrowKeyActiveElement();
    this.isSearching = false;
    if (this.selectedConfig.clearOnSelect) {
      this.clearAll(false, false);
    }
  }
  /**
   * When selected items changes trigger the chaange back to parent
   */
  public valueChanged(IsfireOnChange = true) {

    this.writeValue(this.selectedItems);
    this.onChange(this._value);
    this.setSelectedDisplayText();
    if (IsfireOnChange) {
      this.byChange.emit({ value: this.value });
      this.byValueChange.emit({ value: this.value });
    }

  }
  /**
   * Toggle the dropdownlist on/off
   */
  public toggleSelectDropdown() {
    this.toggleDropdown = !this.toggleDropdown;
    if (this.toggleDropdown) {
      this.byOpen.emit();
    } else {
      this.byClose.emit();
    }
    this.resetArrowKeyActiveElement();
  }

  /**
   * initialize the config and other properties
   */
  private initDropdownValuesAndOptions() {

    this.pageNo = 1;
    let currentSelectedItems = this.getSelectdItems();
    const settings = this.common.getSettings();
    const clientSetting = settings.ClientSetting;
    let loadInitialRecord = false;
    let pageSize = 20;
    if (clientSetting != null && clientSetting != '') {
      if (clientSetting.LoadInitialLookupRecord != null && clientSetting.LoadInitialLookupRecord != undefined) {
        loadInitialRecord = clientSetting.LoadInitialLookupRecord;
      }
      if (clientSetting.PageSize != null && clientSetting.PageSize != undefined) {
        pageSize = clientSetting.PageSize;
      }

    }



    const config: IConfig = {
      displayKey: 'text',
      height: '250px',
      search: false,
      placeholder: this.common.GetTranslation('Common.DropdownPlaceHolder'),
      searchPlaceholder: 'Search',
      limitTo: this.options.length,
      customComparator: undefined,
      noResultsFound: 'No results found!',
      moreText: 'more',
      searchOnKey: "",
      serverSide: false,
      url: '',
      customClass: '',
      isOlderVersion: false,
      loadInitialRecord: loadInitialRecord,
      pageSize: pageSize,
      loadSavedValue: false,
      methodName: '',
      // eventType: "",
      clearOnSelect: false
    };
    if (this.selectedConfig == null || Object.keys(this.selectedConfig).length === 0) {
      this.selectedConfig = { ...config };
    }

    for (const key of Object.keys(config)) {
      (this.selectedConfig as any)[key] = (this.selectedConfig as any)[key] ? (this.selectedConfig as any)[key] : (config as any)[key];
    }

    this.orignalPlaceHolder = this.selectedConfig.placeholder ?? "";

    // Adding placeholder in config as default param
    this.selectedDisplayText = this.selectedConfig['placeholder'] ?? "";
    if (this.value !== '' && typeof this.value !== 'undefined') {
      if (Array.isArray(this.value)) {
        currentSelectedItems = this.value;
      } else {
        currentSelectedItems[0] = this.value;
      }
    }
    this.setSelectedItems(currentSelectedItems);
    this.makeSelectedAndAvailbleArray();
    this.setSelectedDisplayText();
  }
  /**
  * set add Selected and avaialble items to array
  */
  private makeSelectedAndAvailbleArray() {
    this.selectedItems = [...this.options.filter((item: any) => item.selected)];
    this.availableItems = [...this.options.filter((item: any) => !item.selected)];

    if (this.searchText != '') {
      this.filterdtems = this.availableItems.filter((x: any) => x[this.selectedConfig.displayKey ?? ""].toLowerCase().indexOf(this.searchText) != -1);

    } else {
      this.filterdtems = [...this.options.filter((item: any) => !item.selected)];
    }

    if (!this.multiple) {
      this.availableItems = [...this.options.filter((item: any) => !item.selected)];
      this.filterdtems = this.availableItems;
    }
  }
  private getSelectdItems() {
    return this.options.filter((item: any) => item.selected);
  }
  //private getAvailableItems() {
  //  return this.availableItems = this.options.filter(item => !item.selected);
  //}

  public setSelectedItems(currentSelectedItems: any) {

    try {
      if (typeof currentSelectedItems !== 'object') {

        return;
      }
      if (!this.selectedConfig.loadSavedValue) {
        if (!this.options || this.options.length == 0) {
          return;
        }
      }
      this.options.forEach((item: any) => {
        item[this.selectItemKey] = false;
      });

      currentSelectedItems.forEach((item: any) => {
        item[this.selectItemKey] = false;
      });

      if (!this.multiple) {
        currentSelectedItems.forEach((item: any) => {
          let selectedItem = this.options.filter((aItem: any) => JSON.stringify(item) === JSON.stringify(aItem))[0];
          const selector = this.getSelector();
          if (selectedItem == null && selectedItem == undefined) {
            selectedItem = this.options.filter((aItem: any) => item[selector] == aItem[selector])[0];
          }


          if (selectedItem != null && selectedItem != undefined) {
            selectedItem[this.selectItemKey] = true;
          } else if (this.selectedConfig.serverSide && this.selectedConfig.loadSavedValue) {
            this.loadSaveValue(currentSelectedItems[0][selector], selector);
          }
        });
      }
      else {
        for (let i = 0; i < currentSelectedItems.length; i++) {
          const item = currentSelectedItems[i];

          const selector = this.getSelector();
          let selectedItemFound = false;

          for (let j = 0; j < this.options.length; j++) {
            let option = this.options[j];
            if (JSON.stringify(item) === JSON.stringify(option)) {
              option[this.selectItemKey] = true;
              selectedItemFound = true;
              break;
            }
          }


          if (!selectedItemFound && this.selectedConfig.serverSide && this.selectedConfig.loadSavedValue) {
            const saveValues = currentSelectedItems.map((currentSelectedItem: any) => currentSelectedItem[selector]).join(',');
            this.loadSaveValue(saveValues, selector);
          }
        }
      }

      this.makeSelectedAndAvailbleArray();
      this.setSelectedDisplayText();
    } catch (e) {

    }
  }


  private getSelector() {
    const firstOption = this.options[0];
    let selector = 'id';
    if (firstOption) {
      if (firstOption.hasOwnProperty('id')) {
        selector = 'id';
      } else if (firstOption.hasOwnProperty('value')) {
        selector = 'value';
      } else if (firstOption.hasOwnProperty('text')) {
        selector = 'text';
      }
    }
    return selector;
  }

  /**
   * set the text to be displayed
   */
  private setSelectedDisplayText() {
    this.selectedCount = this.selectedItems.length;
    if (this.multiple && this.toggleDropdown) {
      // console.log("Width:" + this.searchBox.nativeElement.offsetWidth);
      if (this.selectedItems.length > 0) {
        this.selectedConfig.placeholder = ' ';
      } else {
        this.selectedConfig.placeholder = '';
      }

      return;
    }
    let text: string = this.selectedItems[0];
    if (typeof this.selectedItems[0] === 'object') {
      text = this.selectedItems[0][this.selectedConfig.displayKey ?? ""];
    }

    if (this.multiple && this.selectedItems.length > 0) {

      this.selectedDisplayText = this.selectedItems.length === 1 ? text :
        text + ` + ${this.selectedItems.length - 1} ${this.selectedConfig.moreText}`;
    } else {
      this.selectedDisplayText = this.selectedItems.length === 0 ? '' : text;
    }
  }

  /**
   * Event handler for arrow key up event thats focuses on a item
   */
  private onArrowKeyUp() {
    if (this.focusedItemIndex === 0) {
      this.focusedItemIndex = this.availableItems.length - 1;
      return;
    }
    if (this.onArrowKey()) {
      if (this.focusedItemIndex)
        this.focusedItemIndex--;
    }
  }

  /**
   * Event handler for arrow key down event thats focuses on a item
   */
  private onArrowKeyDown() {
    if (this.focusedItemIndex === this.availableItems.length - 1) {
      this.focusedItemIndex = 0;
      return;
    }
    if (this.onArrowKey()) {
      if (this.focusedItemIndex || this.focusedItemIndex === 0)
        this.focusedItemIndex++;

    }
  }

  private onArrowKey() {
    if (this.focusedItemIndex === null) {
      this.focusedItemIndex = 0;
      return false;
    }
    return true;
  }

  /**
   * will reset the element that is marked active using arrow keys
   */
  private resetArrowKeyActiveElement() {
    this.focusedItemIndex = null;

  }
  public onKeyup(event: any) {

    if (event.keyCode != 40 && event.keyCode != 9) {
      this.searchText = event.target.value.toString().trim().toLowerCase();
      if (this.selectedConfig.serverSide && this.selectedConfig.url != '') {
        this.pageNo = 1;
        this.populateData();
      } else {
        this.filterdtems = this.availableItems.filter((x: any) => x[this.selectedConfig.displayKey ?? ""].toLowerCase().indexOf(this.searchText) != -1);
      }
      this.isArrowPress = false;
      this.isSearching = true;
    }
  }

  private loadSaveValue(value: string, selector = 'id') {
    if (this.common.isNullOrWhiteSpace(value) || value == null || value == undefined) {
      return;
    }
    // this.config.loadSavedValue = false;
    let url = this.selectedConfig.url;
    const prams = {
      ServerSide: this.selectedConfig.serverSide,
      PageSize: this.selectedConfig.pageSize,
      CustomParameters: this.selectedConfig.customParameters,
      MethodName: this.selectedConfig.methodName,
      SavedValue: this.multiple ? "" : value,
      SavedMultipleValue: this.multiple ? value : "",
      PageNo: 1,
      SearchText: ''
      // eventType: this.config.eventType
    };

    if (this.selectedConfig.params) {
      Object.assign(prams, prams, this.selectedConfig.params);
    }

    this.isDataLoading = true;
    this.common.PostData(url, prams).then(data => {
      this.isDataLoading = false;
      if (data.status == StatusCode.OK) {

        // this.config.loadSavedValue = false;
        if (!this.multiple) {
          let selectedValue = data.resultData.results[0];
          if (selectedValue != null) {
            const selectedItem = this.findItem(selectedValue);
            if (selectedItem != null) {
              selectedItem[this.selectItemKey] = true;
              selectedValue = selectedItem;
            } else {
              this.options.push(selectedValue);
            }
            this.setSelectedItems([selectedValue]);
          }
        }
        else {
          let selectedValues = data.resultData.results;
          if (selectedValues != null && selectedValues.length > 0) {
            const selectedItems = this.findItems(selectedValues);
            if (selectedItems != null && selectedItems.length > 0) {
              selectedItems.forEach((item: any) => {
                item[this.selectItemKey] = true;
              });
              selectedValues = selectedItems;
            } else {
              this.options = this.options.concat(selectedValues);

            }
            this.setSelectedItems(selectedValues);

          }
        }
      }
      this.cdref.markForCheck();
    });
  }
  public findItem(item: any) {
    const selector = this.getSelector();
    return this.options.filter((aItem: any) => item[selector] == aItem[selector])[0];

  }
  findItems(items: any) {
    const selector = this.getSelector();
    let result = this.options.filter((optionItem: any) =>
      items.some((item: any) => item[selector] === optionItem[selector])
    );
    return result;
  }
  public addReadOnly() {

    if (this.searchBox) {

      __ngRendererSetElementAttributeHelper(this.renderer, this.searchBox.nativeElement, 'readonly', 'true');
    }

  }

  public populateData(forceReload = false, appendRecord = false) {

    if (!this.selectedConfig.serverSide) {
      return;
    }

    // weather to load record if searchbox is empty
    // record will be loaded forcefully in case of forceReload witout checking if searhbox has value
    // or not
    // if loadInitialRecord=true then reord will be reloaded on empty search
    if (!forceReload && !this.selectedConfig.loadInitialRecord && this.searchText != '' && this.searchText.trim() == '') {
      if (!this.multiple) {
        this.options = [];
        this.makeSelectedAndAvailbleArray();
      } else {
        if (!appendRecord) {
          this.options = [...this.options.filter((item: any) => item.selected)];
        }
      }
      return;
    }


    if (this.multiple && !appendRecord) {
      this.options = [...this.options.filter((item: any) => item.selected)];
      appendRecord = true;
    }

    let url = this.selectedConfig.url;
    let prams = {
      SearchText: this.searchText,
      ServerSide: this.selectedConfig.serverSide,
      PageSize: this.selectedConfig.pageSize,
      CustomParameters: this.selectedConfig.customParameters,
      MethodName: this.selectedConfig.methodName,
      PageNo: this.pageNo,
      // eventType: this.config.eventType
    };
    if (this.selectedConfig.params) {
      Object.assign(prams, prams, this.selectedConfig.params);
    }

    // let urlParams = new URLSearchParams();
    // for (let key in prams) {
    //  urlParams.set(key, prams[key])
    // }

    // url = url + urlParams.toString();

    this.isDataLoading = true;
    // let timer = Observable.ti(2000, 1000);
    // var ticks = 0;
    // timer.subscribe(t => ticks = t);    
    this.common.PostData(url, prams).then(data => {
      this.isDataLoading = false;
      if (data.status == StatusCode.OK) {
        const results = data.resultData.results;
        if (appendRecord) {
          for (const i in results) {
            const option = results[i];
            if (this.findItem(option) == null) {
              this.options.push(option);
            }
          }
        } else {
          this.options = results;
        }
        for (const i in this.options) {
          const option = this.options[i];
          option[this.selectedConfig.displayKey ?? ""] = this.common.decodeHTMLEntities(option[this.selectedConfig.displayKey ?? ""]);
        }
        this.makeSelectedAndAvailbleArray();
        if (this.selectedConfig.serverSide) {
          this.pageNo = this.pageNo + 1;
        }
      } else {

      }
      this.cdref.markForCheck();

    });
  }
  public focusout(e: any) {
    // alert('focus out');
    const $this = this;
    if ((e && (e.relatedTarget == null || e.relatedTarget.classList.contains('form-control'))) && (!this.isArrowPress)) {
      setTimeout(function () {
        if ($this.selectedItems.length > 0) {
          const serachText = $this.searchBox.nativeElement.value;
          if (($this.selectedItems[0][$this.selectedConfig.displayKey ?? ""]).toLowerCase() != serachText.toLowerCase()) {
            // $this.selectedDisplayText = "";
            $this.setSelectedDisplayText();
            // $this.clearAll(false);
            $this.searchText = '';
            $this.toggleDropdown = false;
          } else {
            $this.toggleDropdown = false;
          }
        } else {
          // $this.selectedDisplayText = "";
          $this.setSelectedDisplayText();
          // $this.clearAll(false);
          // $this.searchText = "";
          $this.toggleDropdown = false;
        }
      }, 100);
    }
  }
  onScrollDown() {
    if (this.selectedConfig.serverSide) {
      this.populateData(true, true);
    }
  }
}

export interface IConfig {
  displayKey?: string,
  dataBindingKey?: string,
  height?: string,
  search?: boolean,
  placeholder?: string,
  searchPlaceholder?: string,
  limitTo?: number,
  customComparator?: string,
  noResultsFound?: string,
  moreText?: string,
  searchOnKey?: string,
  serverSide?: boolean,
  url?: any,
  params?: any,
  customClass?: string,
  isOlderVersion?: boolean,
  loadInitialRecord?: boolean,
  pageSize?: number,
  loadSavedValue?: boolean,
  methodName?: string,
  //eventType?: string,
  customParameters?: keyValue<string, string>[],
  clearOnSelect?: boolean,
  isSubTitle?: boolean,
  subTitleDisplayKey?: string,
  buttonLabel?: string;
  buttonKey?: string;
  isActive?: boolean;
}

type AnyDuringRendererMigration = any;

function __ngRendererSplitNamespaceHelper(name: AnyDuringRendererMigration) {
  if (name[0] === ":") {
    const match = name.match(/^:([^:]+):(.+)$/);
    return [match[1], match[2]];
  }
  return ["", name];
}

function __ngRendererSetElementAttributeHelper(renderer: AnyDuringRendererMigration, element: AnyDuringRendererMigration, namespaceAndName: AnyDuringRendererMigration, value?: AnyDuringRendererMigration) {
  const [namespace, name] = __ngRendererSplitNamespaceHelper(namespaceAndName);
  if (value != null) {
    renderer.setAttribute(element, name, value, namespace);
  }
  else {
    renderer.removeAttribute(element, name, namespace);
  }
}
